<template>
  <div class="home">
    <img src="../assets/images/1.png" alt="">
    <img src="../assets/images/2.png" alt="">
    <img src="../assets/images/3.png" alt="">
    <img src="../assets/images/4.png" alt="">
    <img src="../assets/images/5.png" alt="">
  </div>
</template>

<script>
  export default {
    name: "home",
    created() {
      document.title = '出发前就可以订好车位，再也不用担心违章停车了';
    }
  }
</script>

<style lang="scss" type="text/scss">
  .home{
    width: 100%;
    height: 100%;
    img{
      width: 100%;
      display: block;
    }
  }
</style>